import ServerInstance from "./server.api";

class RentEndpoints extends ServerInstance {
    async getRents() {
        try {
            const response = await this.get("rent");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async verifyRent(trxiD) {
        try {
            const response = await this.patch(`rent/verify/${trxiD}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async verifyDeposit(trxiD) {
        try {
            const response = await this.patch(`deposit/verify/${trxiD}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async refundTransaction(trxiD) {
        try {
            const response = await this.patch(`property/transaction/${trxiD}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default RentEndpoints;
